import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';
export const ALERT_MAX_CAMPAIGNS: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'alert.custom.max_campaigns_reached',
    translate: true,
  },
};
